import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
.heading {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${csSpacing.spacing04};
}

.product-name {
  padding-top: ${csSpacing.spacing05};
}

::slotted([slot="suffix"]) {
    flex-basis: 100%;
}

.info .suffix-divider {
    display: none;
}

@media (min-width: 768px) {
    ::slotted([slot="suffix"]) {
        flex-basis: auto;
    }

    .info .suffix-divider {
        display: inline-block;
    }
}
`
